import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3335/v1';

export const META_COLLECT_API = axios.create({
  baseURL: API_URL,
});
